import type { MaybeRefOrGetter } from 'vue';
import type { SectionId } from '~/types/sectionId';
import log from '~/utils/log';

export function usePlatformLabel(sectionId: MaybeRefOrGetter<SectionId> = 'root') {
    const { t } = useI18n();

    return computed(() => {
        const id = toValue(sectionId);

        switch (id) {
            case 'fachportal':
                return t('platform.prescriber');
            case 'pta-family':
                return t('platform.pta');
            case 'academy':
                return t('platform.academy');
            case 'urology':
                return t('platform.urology');
            case 'nephrology':
                return t('platform.nephrology');
            case 'root':
                return 'Health Family';
            default: {
                log.warn(`[usePlatformLabel] Unknown section id "${id}", falling back to "Health Family".`);
                return 'Health Family';
            }
        }
    });
}
